
/**
 * Current programs supported
 *
 * @export
 */
export enum Program {
  ACC = "ACC",
  FE = "FE",
  MS1 = "MS1"
}

/**
 * Questions' sections
 *
 * @export
 */
export enum QuestionSection {
  A = "A",
  B = "B",
  PQ = "PQ",
  AgentInformation = "AI",
  PaymentInformation = "PI",
  OwnerInformation = "OI",
  PaymentInformation2 = "PMTI"
}

/**
 * Questions' Tags
 *
 * @export
 */
export enum QuestionTag {
  TakingMedication = "TakingMedication",
  BeneficiaryRelationship = "BeneficiaryRelationship",
  SomeoneElsePayingPremium = "SomeoneElsePayingPremium",
  ThirdPartyAuthorizationDisclosure = "Question_Authorization_Disclosure"
}

export enum BoxQuestionComponentStyle {
  RadioButton = "RadioButton",
  InputField = "InputField",
  RadioButtonInputField = "RadioButtonInputField"
}

export enum DataLayerCustomDimensions {
  Client = "client",
  PageName = "pageName",
  Step = "step",
  Event = "event"
}

export enum AnalyticsResourcesNames {
  DashboardGetQuoteBtn = "Get a Quote",
  DashboardGetQuoteNavBtn = "Get a Quote Nav",
  DashboardGetCoveredNavBtn = "Get Covered Nav",
  PlanEstimatorAddEstimationBtn = "Add Estimation",
  CustomerPaymentInfoPlaceOrder = "Place Order",
  WhatsCoveredTab = "whats-covered",
  WhatsNotCoveredTab = "whats-not-covered",
  WhatsNotCoveredEnrollNow = "Get Covered Today",
  ProductPlanAddMoreProduct = "add more products",
  GoToCoveragePageBtn = "See Coverage Details",
  GoToPricingPageBtn = "See Pricing Details",
  GoToClaimPageBtn = "File a Claim",
  DashboardLearnMore = "Learn more"
}

export enum AnalyticsPage {
  // Preneed
  SalesApplicationsPage = "salesApplicationsPage",
  PreQuestionsPage = "preQuestionsPage",
  QuestionAPage = "questionAPage",
  QuestionBPage = "questionBPage",
  OptionalQuestionsPage = "optionalQuestionsPage",
  PreneedStepperPage = "preneedStepperPage",
  RateStep = "rateStep",
  AgentInformationStep = "agentInformationStep",
  BeneficiaryStep = "beneficiaryStep",
  CurrentPhysicianStep = "CurrentPhysicianStep",
  OwnerInformationStep = "ownerInformationStep",
  PaymentInformationStep = "paymentInformationStep",
  ProposedInsuredStep = "proposedInsuredStep",
  ReviewAndSignStep = "reviewAndSignStep",
  SecondaryAdresseeStep = "secondaryAdresseeStep",

  // Connected Living
  DeviceInformation = "deviceInformation",
  PlansSearchPanelComponent = "plansSearchPanel",
  PlansSearchResultComponent = "plansSearchResult",
  CustomerInformation = "customerInformation",
  QuestionInformation = "QuestionInformation",
  ReviewPlanDetail = "reviewPlanDetail",
  Confirmation = "confirmation",
  Customers = "customers",
  ActivePolices = "activePolices",
  PolicyDetails = "policyDetails",
  CustomerDetails = "customerDetails",
  EditCustomer = "editCustomer",
  PolicySearch = "policySearch",
  HomePage = 'homePage',
  Dashboard = 'dashboard',
  ElegibilityQuestions = 'elegibilityQuestions',
  Signature = 'signature',
  ManageUsers = 'manageUsers',

  // B2C
  B2CDashboard = "dashboard",
  B2CElegibility = "eligibility",
  B2CPlanEstimator = "plan-estimator",
  B2CFaq = "faq",
  B2CProductPlan = "product-plan",
  B2CContactUs = "contact-us",
  B2CDeclaration = "declaration",
  B2CCustomerPaymentInfo = "customer-payment-info",
  B2CReview = "review",
  B2CConfirmation = "confirmation",
  B2CPageNotFound = "Page Not Found",
  B2CWhatsCovered = "whats-covered",
  B2CCoveragePlan = "coverage-plan",
  B2CPaymentPlan = "payment-plan",
  B2CPricing = "pricing",
  B2CCoveragePage = "coverage",
  B2CFastlane="Fast Lane"
}

export enum AnalyticsPagePath {
  // B2C
  B2CDashboardPath = "/dashboard",
  B2CElegibilityPath = "/eligibility",
  B2CPlanEstimatorPath = "/device-selection",
  B2CFaqPath = "/faq",
  B2CProductPlanPath = "/product-plan",
  B2CContactUsPath = "/contact-us",
  B2CDeclarationPath = "/declaration",
  B2CCustomerPaymentInfoPath = "/customer-payment-info",
  B2CReviewPath = "/review",
  B2CConfirmationPath = "/confirmation",
  B2CPageNotFound = "/page-not-found",
  B2CWhatsCoveredPath = "/whats-covered",
  B2CCoveragePlan = "/coverage-plan",
  B2CPaymentPlan = "/payment-plan",
  B2CPricingPath = "/pricing",
  B2CCoveragePath = "/coverage",
  B2CCoveragePlanPath = "/coverage-plan",
  B2CCyberProtection = "/cyber-protection",
  B2CTechnicalSupport = "/technical-support"
}

export enum AnalyticsEvent {
  CreateNewApplication = "createNewApplication",
  ResumeSales = "resumeSales",
  StartApplication = "startApplication",
  ApplicationOptionalHealthQuestions = "ApplicationOptionalHealthQuestions",
  ApplicationHealthQpartA = "ApplicationHealthQpartA",
  ApplicationHealthQpartB = "ApplicationHealthQpartB",
  ApplicationPersonalHealthInterview = "ApplicationPersonalHealthInterview",
  ApplicationFinalExpense = "ApplicationFinalExpense",
  ApplicationFinalExpenseProgress = "ApplicationFinalExpenseProgress",
  ApplicationCompleted = "ApplicationCompleted",
  ExitApplication = "exitApplication",
  DeniedApplication = "deniedApplication",

  // Connectes living
  SessionStart = "session_start",
  PageView = "page_view",
  PageLoad = "pageLoad",
  ApplicationStart = "applicationStart",
  DeclinePackage = "declinePackage",
  ApplicationCancel = "applicationCancel",
  ApplicationCheckout = "applicationCheckout",
  ApplicationError = "error",

  // B2C
  EmailContact = "emailContact",
  FileClaim = "fileClaim",
  PlanEstimatorDeviceType = "planEstimator_name",
  PlanEstimatorDeviceMake = "planEstimator_make",
  PlanEstimatorDeviceModel = "planEstimator_model",
  CheckoutDeclarationSectionReached = "eec_checkout_1",
  CheckoutPersonalInfoSectionReached = "eec_checkout_2",
  CheckoutPaymentSectionReached = "eec_checkout_3",
  Checkout = "eec_checkout",
  AddToCart = "eec_cartAdd",
  Transaction = "eec_transaction",
  FaqAccordion = "faqAccordion",
  ModelView = "modal_view",
  TabClick = "tabClick",
  CtaLink = "ctaLink",
  //Samsung
  CheckoutPaymentPlanReached = "eec_checkout_1",
  CheckoutDeclarationReached = "eec_checkout_2",
  CheckoutDeviceIdentifierReached = "eec_checkout_3",
  CheckoutPersonalInfoReached = "eec_checkout_4",
  CheckoutPaymentReached = "eec_checkout_5",
  IMEIError = "error",
}

// export enum ErrorType {
//   Error = "Error",
//   CriticalError = "CriticalError",
//   ReferenceError = "ReferenceError",
//   TypeError = "TypeError",
//   ValidationError = "ValidationError",
//   HttpErrorResponse = "HttpErrorResponse"
// }

export enum PaymentTerms {
  ThreeYears = "3",
  FiveYears = "5",
  SevenYears = "7",
  TenYears = "10",
  FifeteenYears = "15",
  TwentyYears = "20"
}

export enum PaymentTermTypes {
  SinglePay = "SINGLE PAY",
  TimePay = "TIME PAY"
}

export enum NonCitizenIdentifications {
  SSN = "SSN",
  ImmigrationCard = "ImmigrationCard",
  None = "None"
}

export enum PlanTypes {
  Underwritten = "UNDERWRITTEN",
  Guaranteed = "GUARANTEED"
}

export type FullCustomDimensionsSet = {
  [key in DataLayerCustomDimensions]: string | undefined
}

export enum PreneedFlowSteps {
  IsProposedInsuredCompleted = "isProposedInsuredCompleted",
  IsReplacementCompleted = "isReplacementCompleted",
  IsSecondaryAdresseCompleted = "isSecondaryAdresseCompleted",
  IsOwnerInformationCompleted = "isOwnerInformationCompleted",
  IsBeneficiaryCompleted = "isBeneficiaryCompleted",
  IsCurrentPhysicianCompleted = "isCurrentPhysicianCompleted",
  IsPaymentInformationCompleted = "isPaymentInformationCompleted",
  IsAgentInformationCompleted = "isAgentInformationCompleted",
  IsReviewAndSignCompleted = "isReviewAndSignCompleted",
}

export enum ClientType {
  Estate = "Estate of Insured",
  Trust = "Trust",
  Individual = "Individual",
  None = "None",
}

export enum UnderwritingStatus {
  Approved = 6,
  Declined = 7,
  Unknown = 0
}

export enum ProposedInsuredPresent {
  Yes = "Yes",
  No = "No",
  VideoConferenceSale = "Video Conference Sale"
}

export enum ComponentName {
  PreHealthQuestions = "PreHealthQuestions",
  HealthQuestions = "HealthQuestions",
  RateStep = "RateStep",
  ReplacementStep = "ReplacementStep",
  AgentInformation = "AgentInformation",
  BeneficiaryStep = "BeneficiaryStep",
  ProposedInsuredStep = "ProposedInsuredStep",
  SecondaryAddressee = "SecondaryAddressee",
  OwnerInformationStep = "OwnerInformationStep",
  CurrentPhysician = "CurrentPhysician",
  PaymentInformationStep = "PaymentInformationStep",
  ReviewAndSignStep = "ReviewAndSignStep",
  QuestionsStep = "QuestionAnswerStep"
}

export enum BeneficiaryType {
  Primary = "Primary",
  Contingent = "Contingent"
}

export enum Prefix {
  Blank = "Blank",
}

export enum Suffix {
  Blank = "Blank",
}

export enum PayorOption {
  SomeoneElse = "Someone else",
  ProposedInsured = "Proposed Insured",
  Owner = "Owner"
}
export enum AULRole {
  Director = "Director",
  RegionalManager = "Regional Manager",
  SalesManager = "Sales Manager",
  Salesman = "Salesman",
  StoreManager = "Store Manager",
  Agent = "Agent",
  Guest = "Guest",
  Admin = "Admin",
  User = "_User",
}

export const enum Transforms {
  Transform0 = "translateX(0px)",
  Transform100 = "translateX(100%)"
}

/**
 * Navigation Stepper Action Types
 *
 * @export
 * @enum {number}
 */
export enum StepperActionType {
  None = 0,
  GoBack = 1,
  GoNext = 2,
}

export enum D2CComponentName {
  CustomerInfo = "CustomerInfo"
}

export enum UnderwritingResultTypes {
  Accepted = 10,
  InReview = 20,
  Declined = 30,
  NoResults = -1
}

export enum UnderwritingRiskClass {
  Unknown = -1,
  Preferred = 7,
  Standard = 8,
  PreferredSmoking = 9,
  StandardSmoking = 10
}

export enum D2CClient {
  D2C = "D2C",
  Luxottica = "LUX",
  PYB = "PYB"
}


export enum PricingPlanTypeIT {
  TwoYear = "2 anni",
  OneYear = "1 anno",
  Monthly = "Mensile",
  Excess = "Franchigia",
}

export enum PricingPlanTypeUK {
  TwoYear = "2 Year",
  OneYear = "1 Year",
  Monthly = "Monthly",
  Excess = "Excess",
}

export enum LoginType {
  SSO = "SSO",
  Login = "Login",
}

export enum Global_Client {
  D2C = "D2C",
  B2B = "B2B",
}

export enum DateFormat {
  ElitaDateFormat = "MM/DD/YYYY"
}

export enum SCCoverageType {
  SC_ADT = "SC_ADT",
  SC_AD = "SC_AD",
  SC_ADTL = "SC_ADTL"
}
export enum GadgetCoverageType {
  Gadget_ADTL = "Gadget_ADTL",
  Gadget_ADT = "Gadget_ADT",
   Gadget_ADE_24 = "Gadget_ADE_24",
   Gadget_ADE_36 = "Gadget_ADE_36",
}
export enum RiskTypeCoverageType {
  RiskType_E = "RiskType_E",
}
export enum SCCoverageTypeCategory {
  Theft = "T2",
  Accidental = "A",
  AccidentalAndTheft = "AT2",
  TheftAndLoss = "T",
  Extended = "E"
}

export enum SCCoverageTypeCode {
  Excess = "Excess",
  MaxClaim = "MaxClaim"
}

export enum CoverageServicesType {
  Covered = "Covered",
  NotCovered = "NotCovered",
  Services = "Services"
}

export enum PlanDurationType {
  Monthly = "monthly",
  Yearly = "yearly",
}

export enum EventResponseType {
  Accept = "Accept",
  Decline = "Decline",
}

export enum GPMGatewayProfileUsageType {
  Unscheduled = 1
}

export enum GPMGatewayRequestOriginType {
  WebSelfService = 1
}

export enum GPMGatewaySourceSystemType {
  Elita = 2
}

export enum GPMGatewaySourceSystemContextType {
  Policy = 1
}

export enum GPMGatewayTransactionTypeType {
  Verify = 1
}

export enum PaymentInstrumentType {
  GP = "GP",
  B = "B",
}

export enum DeviceTypeCode {
  SmartPhone = "SMRT",
  Tablet = "TAB",
  Computer = "LPTP",
  Watch = "SMTWTCH",
}

export enum PromoOfferType {
  Percent = "Percent",
  Flat = "Flat",
  Fixed_Price = "Fixed_Price",
  Free_Month = "Free_Month",
}

export enum CoverageServices {
  What_Is_Covered = "WC",
  What_Is_NotCovered = "WNC",
  Services_Provided = "SP"
}

export enum CoveragePlans {
  Coverage = "CVG",
  Common = "Common"
}

export enum ActiveorInactiveToggle {
  Inactive = 'inactive',
  Active = 'active'
}

